import { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { ButtonUI, ModalUI, showNotification } from 'sonata-react-components';

import type { Pixel } from 'sonata-static-storage/lib/schemas/pixel/pixel.schema';

import './pixelCode.scss';

import { copyPixelCodeToClipboard, getPixelCode } from '@/helpers/pixel/pixel.helper';

type Props = {
  onClose: () => void;
  pixel: Pixel;
};

export function PixelCode({ pixel, onClose }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const modalRef = useRef<React.ElementRef<typeof ModalUI>>(null);

  const BASE_ID = 'pixelCode';

  useEffect(() => {
    modalRef?.current?.openModal();
  }, [modalRef]);

  const handleCopyPixelCode = async () => {
    await copyPixelCodeToClipboard({ pixel });
    showNotification(
      'map',
      formatMessage({
        defaultMessage: 'Pixel code copied to clipboard',
        id: 'menu.pixelCode.copyMessage'
      })
    );
  };

  return (
    <ModalUI
      closeModalCallback={onClose}
      ref={modalRef}
      rightButton={
        <ButtonUI
          className="pixelCode_doneButton"
          id={`${BASE_ID}_doneBtn`}
          onClick={onClose}
          text={formatMessage({
            defaultMessage: 'Done',
            id: 'common.done'
          })}
          type="primary"
        />
      }
      title={formatMessage({
        defaultMessage: 'Pixel code',
        id: 'menu.pixelCode.title'
      })}
      width="850px"
    >
      <div className="pixelCode">
        <p className="pixelCode__description">
          {formatMessage({
            defaultMessage: 'The pixel code tag goes in the page where the conversion takes place.',
            id: 'menu.pixelCode.message'
          })}
        </p>
        <span className="pixelCode__tag">{getPixelCode(pixel)}</span>
        <ButtonUI
          className="myPixels_newButton"
          icon="fa-regular fa-copy"
          id={`${BASE_ID}_newPixelBtn`}
          onClick={handleCopyPixelCode}
          shape="link"
          size="small"
          type="tertiary"
        />
      </div>
    </ModalUI>
  );
}
